function History(raw) {
    this.raw = raw;
}
History.prototype.getId = function () {
    return this.raw?.id;
};
History.prototype.getPhase = function () {
    return this.raw?.phase;
};
History.prototype.getStep = function () {
    return this.raw?.step;
};
History.prototype.getTitle = function () {
    if (this.raw?.phase) {
        switch (this.raw?.phase) {
            case "entry":
                if (this.raw?.entry) {
                    if (this.raw?.entry.type) {
                        if (this.raw.entry.type == "category") {
                            if (this.raw.entry?.category) {
                                return this.raw.entry.category.title;
                            }
                        }
                        if (this.raw.entry.type == "similar") {
                            if (this.raw.entry?.similar) {
                                return this.raw.entry.similar.title;
                            }
                        }
                    }

                }
                break;
            case "question":
            case "questionnaire":
                if (this.raw?.question?.qa) {
                    return this.raw?.question?.qa?.title;
                }
                break;
        }
    }
    return "";
};
History.prototype.getReplyTitles = function () {
    let ts = []
    if (this.raw?.phase) {
        switch (this.raw?.phase) {
            case "entry":
                if (this.raw?.entry) {
                    console.log("this.raw?.entry?.expectations", this.raw?.entry?.expectations);
                    for (let i in this.raw?.entry?.expectations) {
                        ts.push(
                            this.raw.entry.expectations[i].title
                        );
                    }
                }
                break;
            case "question":
            case "questionnaire":
                if (this.raw?.question?.qa) {
                    for (let i in this.raw.question.qa?.replys) {
                        ts.push(
                            this.raw.question.qa?.replys[i].title
                        );
                    }
                }
                break;
        }
    }
    return ts;
};
History.prototype.getHistoryId = function () {
    if (this.raw?.phase) {
        switch (this.raw?.phase) {
            case "entry":
                if (this.raw?.type) {
                    if (this.raw.type == "category") {
                        if (this.raw?.category) {
                            return this.raw?.category.title;
                        }
                    }
                }
        }
    }
    return "";
};

export { History }